export const DEFAULT_PORTFOLIO_PREFIX = 'Top Level Owner';

export const SECURITY_GROUPING = 'security';

export const DEFAULT_GROUPINGS = ['top_level_owner', 'asset_class', 'roll_up', SECURITY_GROUPING];

export const DEFAULT_RETURN_KEY = 'time_weighted_return';
